<template>
    <l-container class="mt-4">
        <apexchart width="100%" height="300" :options="options" :series="[]" :type="chartType"></apexchart>
    </l-container>
</template>


<script>
import ApexchartHelper from "@/helpers/settings/apexchart";
import VueApexCharts from "vue-apexcharts";
import ApexCharts from "apexcharts";

export default {
    name: "LLChart",
    components: {
        apexchart: VueApexCharts,
    },
    data() {
        return {
            hasData: false,
            options: ApexchartHelper.settings(),
            chartType: "line",
        };
    },
    methods: {
        changeType(type) {
            this.chartType = type;
        },
        removeSeries() {},
        addSeries(series) {
            ApexCharts.exec("apexchart", "updateSeries", series, false); // Avoid slow vue observable object
        },

        updateOptions(options) {
            ApexCharts.exec("apexchart", "updateOptions", options, false);
        },

        updateYaxisStart(yaxisStart) {
            console.log("chart options", this.options);
            if (!this.options.yaxis) this.options.yaxis = {};
            this.options.yaxis.min = yaxisStart;
            console.log("chart options", this.options);

            ApexCharts.exec("apexchart", "updateOptions", this.options);
        },
    },
};
</script>
